import React, { ReactNode, createContext, useContext, useState } from 'react';

interface DeploymentContextProps {
  hasDeployed: boolean;
  setHasDeployed: (hasDeployed: boolean) => void;
}

const DeploymentContext = createContext<DeploymentContextProps | undefined>(undefined);

export const DeploymentProvider: React.FC<{
  children: ReactNode;
  initialHasDeployed: boolean;
}> = ({ children, initialHasDeployed }) => {
  const [hasDeployed, setHasDeployed] = useState<boolean>(initialHasDeployed);

  const value: DeploymentContextProps = { hasDeployed, setHasDeployed };

  return <DeploymentContext.Provider value={value}>{children}</DeploymentContext.Provider>;
};

export const useDeployment = () => {
  const context = useContext(DeploymentContext);
  if (!context) {
    throw new Error('useDeployment must be used within a DeploymentProvider');
  }
  return context;
};
